<template>
  <div v-if="isShowfooter" class="layout-footer animate-fade-in-up" :class="{ 'dark-footer': isDarkFooterPage }">
    <div class="layout-footer-container">
      <div class="layout-footer-linkSelects">
        <div v-for="(dropdown, index) in linkDropdowns" :key="index" class="dropdown-container"
          :class="{ active: dropdown.isOpen }">
          <div class="dropdown-selected" @click="toggleDropdown(index)">
            <span class="selected-text">{{ dropdown.selectedText }}</span>
            <img :src="arrowIcon" alt="arrow" class="dropdown-arrow" :class="{ rotated: dropdown.isOpen }" />
          </div>
          <div class="dropdown-options">
            <a v-for="option in dropdown.options" :key="option.href" :href="option.href" class="dropdown-option"
              target="_blank" @click="selectOption(index, option)">
              {{ option.text }}
            </a>
          </div>
        </div>
      </div>

      <div class="layout-footer-info">
        <div class="info-left">
          <div class="info-list">
            <div v-for="item in contactInfo" :key="item.type" class="list-item">
              <!-- <img
                :src="item.icon"
                :width="item.iconWidth"
                :height="item.iconHeight"
                :alt="item.title"
              /> -->
              <div class="list-item-content">
                <div class="list-item-desc">{{ item.desc }}</div>
                <div class="list-item-title">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="info-right">
          <div class="about-us">
            <!-- <div class="about-us-title">关于我们</div> -->
            <div class="about-us-content">
              <a v-for="link in aboutUsLinks" :key="link.href" :href="link.href" class="about-us-item" target="_blank">
                {{ link.text }}
              </a>
            </div>
          </div>
          <div class="officialAccounts">
            <img :src="officialAccountsIcon" width="120" height="120" alt="微信公众号" />
            <span>关注微信公众号</span>
          </div>
          <div class="filingNumber">
            <img @click="openNumberLink" :src="iconImage" alt="备案图标" />
            <div class="filingNumber-text">
              中国煤炭工业协会培训中心 版权所有 京ICP备17015936号-1
              <br />
              京公网安备11010502042070号
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive, onMounted, onUnmounted, computed } from 'vue';
import { useRoute } from 'vue-router';
// 图片路径 - 使用@/assets/images/的方式
import telphoneIcon from '@/assets/images/footer/telphone.png';
import emailIcon from '@/assets/images/footer/email.png';
import addressIcon from '@/assets/images/footer/address.png';
import arrowIcon from '@/assets/images/common/arrow@2x.png';
import officialAccountsIcon from '@/assets/images/footer/officialAccounts.png';
import iconImage from '@/assets/images/footer/icon.png';
import { fetchHomeJson } from '@/apis/commonApi';
import { useLayout } from '@/composables/useLayout';

const { isShowfooter } = useLayout();
// 类型定义
interface LinkOption {
  text: string;
  href: string;
}

interface LinkDropdown {
  title: string;
  selectedText: string;
  options: LinkOption[];
  isOpen: boolean;
}

interface ContactItem {
  type: string;
  icon: string;
  iconWidth: number;
  iconHeight: number;
  title: string;
  desc: string;
}

interface AboutUsLink {
  text: string;
  href: string;
}

// 响应式数据
const linkDropdowns = reactive<LinkDropdown[]>([
  {
    title: '政府机构',
    selectedText: '政府机构',
    options: [
      { text: '中国煤炭工业协会', href: 'https://www.coalchina.org.cn/' },
      { text: '国家能源局', href: 'http://www.nea.gov.cn/' },
      { text: '中国煤炭科工集团', href: 'https://www.ccteg.cn/' },
      { text: '煤炭工业出版社', href: 'https://www.mtkjcbs.com/' },
      { text: '中煤能源集团', href: 'https://www.chinacoal.com/' },
      { text: '神华集团', href: 'https://www.shenhuagroup.com.cn/' },
    ],
    isOpen: false,
  },
  {
    title: '能源行业',
    selectedText: '能源行业',
    options: [
      { text: '中国煤炭工业协会', href: 'https://www.coalchina.org.cn/' },
      { text: '国家能源局', href: 'http://www.nea.gov.cn/' },
      { text: '中国煤炭科工集团', href: 'https://www.ccteg.cn/' },
      { text: '煤炭工业出版社', href: 'https://www.mtkjcbs.com/' },
      { text: '中煤能源集团', href: 'https://www.chinacoal.com/' },
      { text: '神华集团', href: 'https://www.shenhuagroup.com.cn/' },
    ],
    isOpen: false,
  },
  {
    title: '主流媒体',
    selectedText: '主流媒体',
    options: [
      { text: '中国煤炭工业协会', href: 'https://www.coalchina.org.cn/' },
      { text: '国家能源局', href: 'http://www.nea.gov.cn/' },
      { text: '中国煤炭科工集团', href: 'https://www.ccteg.cn/' },
      { text: '煤炭工业出版社', href: 'https://www.mtkjcbs.com/' },
      { text: '中煤能源集团', href: 'https://www.chinacoal.com/' },
      { text: '神华集团', href: 'https://www.shenhuagroup.com.cn/' },
    ],
    isOpen: false,
  },
  {
    title: '煤炭相关企业',
    selectedText: '煤炭相关企业',
    options: [
      { text: '中国煤炭工业协会', href: 'https://www.coalchina.org.cn/' },
      { text: '国家能源局', href: 'http://www.nea.gov.cn/' },
      { text: '中国煤炭科工集团', href: 'https://www.ccteg.cn/' },
      { text: '煤炭工业出版社', href: 'https://www.mtkjcbs.com/' },
      { text: '中煤能源集团', href: 'https://www.chinacoal.com/' },
      { text: '神华集团', href: 'https://www.shenhuagroup.com.cn/' },
    ],
    isOpen: false,
  },
]);

// 联系信息
const contactInfo: ContactItem[] = [
  {
    type: 'tech',
    icon: telphoneIcon,
    iconWidth: 17,
    iconHeight: 22,
    title: '010-84261764 / 010-84264203',
    desc: '联系方式',
  },
  {
    type: 'email',
    icon: emailIcon,
    iconWidth: 24,
    iconHeight: 21,
    title: 'zmpx1912@126.com',
    desc: '企业邮箱',
  },
  // {
  //   type: 'business',
  //   icon: telphoneIcon,
  //   iconWidth: 17,
  //   iconHeight: 22,
  //   title: '010-84264203',
  //   desc: '商务合作',
  // },
  {
    type: 'address',
    icon: addressIcon,
    iconWidth: 18,
    iconHeight: 24,
    title: '北京市朝阳区和平街13区煤炭大厦17层',
    desc: '联系地址',
  },
];

// 关于我们链接
const aboutUsLinks = ref<AboutUsLink[]>([
  { text: '关于我们', href: '#' },
  { text: '联系我们', href: '#' },
  // { text: '意见反馈', href: '#' },
  // { text: '投诉建议', href: '#' },
]);

const isDarkFooterPage = computed(() => {
  const currentPage = window.location.pathname;
  const darkFooterPages = ['livePlayback.html', 'livePlay.html','liveDetails.html','courseDetails.html','coursePlay.html','specialDetails.html'];
  return darkFooterPages.some((page) => currentPage.includes(page));
});

// 方法
const toggleDropdown = (index: number) => {
  // 关闭其他下拉框
  linkDropdowns.forEach((dropdown: LinkDropdown, i: number) => {
    if (i !== index) {
      dropdown.isOpen = false;
    }
  });

  // 切换当前下拉框
  linkDropdowns[index].isOpen = !linkDropdowns[index].isOpen;
};

const selectOption = (index: number, option: LinkOption) => {
  linkDropdowns[index].selectedText = option.text;
  linkDropdowns[index].isOpen = false;

  // 延迟跳转，让用户看到选中效果
  setTimeout(() => {
    window.open(option.href, '_blank');
  }, 200);
};

const handleClickOutside = (event: Event) => {
  const target = event.target as Element;
  if (!target.closest('.dropdown-container')) {
    linkDropdowns.forEach((dropdown: LinkDropdown) => {
      dropdown.isOpen = false;
    });
  }
};

const handleEscapeKey = (event: KeyboardEvent) => {
  if (event.key === 'Escape') {
    linkDropdowns.forEach((dropdown: LinkDropdown) => {
      dropdown.isOpen = false;
    });
  }
};

// 获取首页数据
const fetchHomeData = async () => {
  try {
    const { data } = await fetchHomeJson();
    console.log(data);

    // 更新关于我们链接
    aboutUsLinks.value[0].href = data.gywm[0].link;
    aboutUsLinks.value[1].href = data.wzxx[0].link;

    // 更新政府机构下拉框数据
    if (data.yqlj_zfjg && Array.isArray(data.yqlj_zfjg)) {
      linkDropdowns[0].options = data.yqlj_zfjg.map((item: any) => ({
        text: item.name || item.title,
        href: item.link || item.url,
      }));
    }

    // 更新能源行业下拉框数据
    if (data.yqlj_nyxy && Array.isArray(data.yqlj_nyxy)) {
      linkDropdowns[1].options = data.yqlj_nyxy.map((item: any) => ({
        text: item.name || item.title,
        href: item.link || item.url,
      }));
    }

    // 更新主流媒体下拉框数据
    if (data.yqlj_zlmt && Array.isArray(data.yqlj_zlmt)) {
      linkDropdowns[2].options = data.yqlj_zlmt.map((item: any) => ({
        text: item.name || item.title,
        href: item.link || item.url,
      }));
    }

    // 更新煤炭相关企业下拉框数据
    if (data.yqlj_mtxgqy && Array.isArray(data.yqlj_mtxgqy)) {
      linkDropdowns[3].options = data.yqlj_mtxgqy.map((item: any) => ({
        text: item.name || item.title,
        href: item.link || item.url,
      }));
    }

    return data;
  } catch (error) {
    console.error('获取首页数据失败:', error);
    return null;
  }
};


const openNumberLink = () => {
  window.open(`https://trust.hss.org.cn/CX885276404735.html`);
};

// 生命周期
onMounted(async () => {
  document.addEventListener('click', handleClickOutside);
  document.addEventListener('keydown', handleEscapeKey);
  fetchHomeData();
});

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
  document.removeEventListener('keydown', handleEscapeKey);
});
</script>

<style scoped lang="scss">
.layout-footer {
  background: #1e51c4;
  height: 260px;
}

.layout-footer-container {
  width: $container-width;
  margin: 0 auto;
}

.layout-footer-linkSelects {
  padding-top: 20px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.dropdown-container {
  position: relative;
}

.dropdown-selected {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #fff;
  border: 1px solid #fff;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  height: 45px;
  box-sizing: border-box;
}

// .dropdown-selected:hover {
//   background: #323539;
//   border-color: #4a4d51;
// }

.selected-text {
  font-size: 18px;
  color: #929396;
}

.dropdown-arrow {
  width: 12px;
  height: 12px;
  transition: transform 0.3s ease;
  // filter: brightness(0) invert(1);
}

.dropdown-container.active .dropdown-arrow {
  transform: rotate(180deg);
}

.dropdown-options {
  position: absolute;
  bottom: 100%;
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #fff;
  border-radius: 6px;
  margin-bottom: 5px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px);
  transition: all 0.3s ease;
  z-index: 1000;
  display: flex;
  flex-direction: column;
}

.dropdown-container.active .dropdown-options {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.dropdown-option {
  padding: 12px 16px;
  font-size: 18px;
  color: #929396;
  cursor: pointer;
  transition: all 0.2s ease;
  // border-bottom: 1px solid #404347;
  text-decoration: none;
}

.dropdown-option:last-child {
  border-bottom: none;
}

.dropdown-option:hover {
  // background: #323539;
  color: #1e51c4;
}

.filingNumber {
  width: 30%;

  @media (min-width:769px) {
    line-height: 0.9;
  }
}

.filingNumber img {
  width: 100px;
  height: 36px;
  cursor: pointer;
  flex-shrink: 0;
}

.filingNumber-text {
  font-family: Alibaba PuHuiTi 2;
  font-weight: normal;
  font-size: 12px;
  color: #ffffff;
  line-height: 20px;
  margin-top: 15px;
}

.layout-footer-filingNumber {
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #151617;
}

.layout-footer-filingNumber>img {
  width: 112px;
  height: 40px;
}

.layout-footer-filingNumber>a {
  margin-left: 40px;
  color: #8f8f8f;
  font-size: 14px;
  text-decoration: none;
  transition: all 0.3s ease;
  position: relative;
  padding: 8px 12px;
  border-radius: 4px;
}

.layout-footer-filingNumber>a:hover {
  color: #ffffff;
  background: rgba(0, 123, 255, 0.1);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.2);
}

.layout-footer-filingNumber>a::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, $primary-color, #00d4ff);
  transition: width 0.3s ease;
}

.layout-footer-filingNumber>a:hover::after {
  width: 80%;
}

.layout-footer-info {
  margin-top: 29px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.info-left {
  width: 45%;
}

.info-list {
  display: flex;
  gap: 25px;
  flex-direction: column;
}

.list-item {
  display: flex;
}

.list-item>img {
  margin-top: 5px;
}

.list-item-content {
  margin-left: 13px;
  display: flex;
  align-items: center;
  gap: 18px;
}

.list-item-title {
  font-size: 20px;
  line-height: 0.3rem;
  color: #ffffff;
  flex-shrink: 0;
}

.list-item-desc {
  font-size: 16px;
  color: #8f8f8f;
  font-family: Alibaba PuHuiTi 2;
  font-weight: normal;
  font-size: 14px;
  color: #96b3f8;
  flex-shrink: 0;
  line-height: 0.8;
}

.info-right {
  display: flex;
  width: 55%;
  justify-content: space-between;
}

.about-us {
  width: 30%;
}

.about-us-title {
  font-size: 20px;
  color: #ffffff !important;
  text-decoration: none;
  transition: all 0.3s ease;
}

.about-us-title:hover {
  color: #4162e9 !important;
  text-shadow: 0 0 8px rgba(0, 123, 255, 0.4);
  transform: translateX(5px);
}

.about-us-content {
  // margin-top: 34px;
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.about-us-item {
  font-size: 16px;
  color: #8f8f8f;
  text-decoration: none;
  transition: all 0.3s ease;
  position: relative;
  font-family: Alibaba PuHuiTi 2;
  font-weight: normal;
  font-size: 14px;
  color: #ffffff;
  height: 21px;
  line-height: 21px;
}

.about-us-item:hover {
  color: #ffffff;
  transform: translateX(8px);
}

.about-us-item::before {
  content: '';
  position: absolute;
  left: -15px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #4162e9, #00d4ff);
  transition: width 0.3s ease;
}

.about-us-item:hover::before {
  width: 10px;
}

.officialAccounts {
  // margin-left: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 40%;
}

.officialAccounts img {
  width: 80px;
  height: 80px;
}

.officialAccounts>span {
  font-size: 16px;
  font-family: Alibaba PuHuiTi 2;
  font-weight: normal;
  font-size: 14px;
  color: #a4c0ff;
  height: 21px;
  margin-top: 12px;
  line-height: 21px;
}

.layout-footer-linkSelects .dropdown-arrow {
  margin-left: 8px;
  width: 15px;
  height: 9px;
  transition: transform 0.3s ease;
}

/* 底部模块响应式适配 */
@media (max-width: 1366px) {
  .layout-footer {
    height: 280px;
  }

  .layout-footer-linkSelects {
    padding-top: 25px;
    gap: 15px;
  }

  .dropdown-selected {
    padding: 10px 14px;
  }

  .selected-text {
    font-size: 16px;
  }

  .dropdown-option {
    font-size: 16px;
  }

  .layout-footer-info {
    margin-top: 40px;
  }

  .info-list {
    gap: 25px;
  }

  .list-item-title {
    font-size: 18px;
  }

  .list-item-desc {
    font-size: 14px;
  }

  .about-us-title {
    font-size: 18px;
  }

  .about-us-content {
    gap: 30px;
  }

  .about-us-item {
    font-size: 14px;
  }

  .officialAccounts {
    // margin-left: 120px;
  }

  .officialAccounts>span {
    font-size: 14px;
  }

  .layout-footer-filingNumber {
    height: 60px;
  }

  .layout-footer-filingNumber>img {
    width: 100px;
    height: 36px;
  }

  .layout-footer-filingNumber>a {
    margin-left: 30px;
    font-size: 13px;
  }
}

@media (max-width: 1200px) {
  .layout-footer {
    height: 320px;
  }

  .layout-footer-container {
    height: 250px;
  }

  .layout-footer-linkSelects {
    padding-top: 20px;
    gap: 12px;
  }

  .dropdown-selected {
    padding: 8px 12px;
  }

  .selected-text {
    font-size: 15px;
  }

  .dropdown-option {
    font-size: 15px;
  }

  .layout-footer-info {
    margin-top: 35px;
  }

  .info-list {
    gap: 12px;
  }

  .list-item-title {
    font-size: 16px;
  }

  .list-item-desc {
    font-size: 13px;
  }

  .about-us-title {
    font-size: 16px;
  }

  .about-us-content {
    gap: 12px;
  }

  .about-us-item {
    font-size: 13px;
  }

  .officialAccounts {
    // margin-left: 100px;
  }

  .officialAccounts>span {
    font-size: 13px;
  }

  .layout-footer-filingNumber {
    height: 55px;
  }

  .layout-footer-filingNumber>img {
    width: 90px;
    height: 32px;
  }

  .layout-footer-filingNumber>a {
    margin-left: 25px;
    font-size: 12px;
  }
}

@media (max-width: 1024px) {
  .layout-footer {
    height: auto;
    min-height: 300px;
  }

  .officialAccounts {
    align-items: center;
  }

  .layout-footer-container {
    height: auto;
  }

  .layout-footer-linkSelects {
    padding-top: 25px;
    gap: 15px;
  }

  .dropdown-selected {
    padding: 10px 14px;
  }

  .selected-text {
    font-size: 15px;
  }

  .dropdown-option {
    font-size: 15px;
  }

  .layout-footer-info {
    margin-top: 30px;
    flex-direction: column;
    gap: 30px;
  }

  .info-left {
    width: 100%;
  }

  .info-list {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 15px;
  }

  .list-item-title {
    font-size: 16px;
  }

  .list-item-desc {
    font-size: 13px;
  }

  .info-right {
    justify-content: space-between;
    width: 100%;
    padding: 0 10px;
    flex-wrap: wrap;
    box-sizing: border-box;
  }

  .about-us-title {
    font-size: 16px;
  }

  .about-us-content {
    gap: 10px;
  }

  .about-us-item {
    font-size: 13px;
  }

  .officialAccounts {
    margin-left: 0;
  }

  .officialAccounts>span {
    font-size: 13px;
  }

  .layout-footer-filingNumber {
    height: 50px;
  }

  .layout-footer-filingNumber>img {
    width: 80px;
    height: 28px;
  }

  .layout-footer-filingNumber>a {
    margin-left: 20px;
    font-size: 12px;
  }
}

@media (max-width: 768px) {
  .layout-footer {
    min-height: 280px;
  }

  .layout-footer-linkSelects {
    padding-top: 20px;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }

  .dropdown-selected {
    padding: 8px 12px;
    height: 30px;
  }

  .selected-text {
    font-size: 14px;
  }

  .dropdown-option {
    font-size: 14px;
  }

  .layout-footer-info {
    margin-top: 25px;
    gap: 25px;
  }

  .info-list {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .list-item-title {
    font-size: 15px;
  }

  .list-item {
    height: 18px;
  }

  .list-item-desc {
    font-size: 12px;
    height: 18px;
    line-height: 20px;
  }

  .info-right {
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    padding-bottom: 20px;
  }

  .filingNumber {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .filingNumber-text {
    margin-top: 0;
  }

  .about-us-title {
    font-size: 15px;
    text-align: center;
  }

  .about-us {
    margin-top: 10px;
  }


  .about-us-content {
    gap: 40px;
    align-items: center;
    flex-direction: row;
    transform: translateX(-20%);
    height: 18px;
  }

  .about-us-item {
    font-size: 12px;
    flex-shrink: 0;
    height: 18px;
    line-height: 18px;
  }

  .officialAccounts {
    margin-left: 0;
    align-items: center;
  }

  .officialAccounts>span {
    font-size: 12px;
    margin-top: 12px;
    line-height: 18px;
    height: 18px;
  }

  .layout-footer-filingNumber {
    height: 45px;
  }

  .layout-footer-filingNumber>img {
    width: 70px;
    height: 25px;
  }

  .layout-footer-filingNumber>a {
    margin-left: 15px;
    font-size: 12px;
  }
}

@media (max-width: 600px) {
  .layout-footer {
    min-height: 260px;
  }

  .layout-footer-linkSelects {
    padding-top: 15px;
    gap: 10px;
  }

  .dropdown-selected {
    padding: 6px 10px;
  }

  .selected-text {
    font-size: 13px;
  }

  .dropdown-option {
    font-size: 13px;
  }

  .layout-footer-info {
    margin-top: 20px;
    gap: 20px;
  }

  .info-list {
    gap: 10px;
  }

  .list-item-title {
    font-size: 14px;
  }

  .list-item-desc {
    font-size: 12px;
  }

  .info-right {
    gap: 15px;
  }

  .about-us-title {
    font-size: 14px;
  }


  .about-us-item {
    font-size: 12px;
  }

  .officialAccounts>span {
    font-size: 12px;
  }

  .layout-footer-filingNumber {
    height: 40px;
  }

  .layout-footer-filingNumber>img {
    width: 60px;
    height: 22px;
  }
}

@media (max-width: 480px) {
  .layout-footer {
    min-height: 240px;
  }

  .layout-footer-linkSelects {
    padding-top: 12px;
    gap: 8px;
  }

  .dropdown-selected {
    padding: 5px 8px;
  }

  .selected-text {
    font-size: 12px;
  }

  .dropdown-option {
    padding: 5px 8px;
    font-size: 12px;
  }

  .layout-footer-info {
    margin-top: 15px;
    gap: 15px;
  }

  .info-list {
    gap: 8px;
  }

  .list-item-title {
    font-size: 13px;
  }

  .list-item-desc {
    font-size: 12px;
  }

  .info-right {
    gap: 12px;
  }

  .about-us-title {
    font-size: 13px;
  }

  .about-us-item {
    font-size: 12px;
  }

  .officialAccounts>span {
    font-size: 12px;
  }

  .layout-footer-filingNumber {
    height: 35px;
  }

  .layout-footer-filingNumber>img {
    width: 50px;
    height: 18px;
  }
}

/* 黑暗页脚样式 */
.dark-footer {
  background: #212225 !important;

  .officialAccounts>span,
  .list-item-desc {
    color: #979797 !important;
  }

  .dropdown-selected {
    background: #2a2d30;
    border: 1px solid #404347;
  }

  .dropdown-selected:hover {
    background: #323539;
    border-color: #4a4d51;
  }

  .dropdown-options {
    background: #2a2d30;
    border: 1px solid #404347;
  }

  .dropdown-option:last-child {
    border-bottom: none;
  }

  .dropdown-option:hover {
    background: #323539;
    color: #ffffff;
  }
}
</style>
